
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Group_49133","data-name":"Group 49133","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_49134","data-name":"Group 49134"}},[_c('path',{attrs:{"id":"Path_38427","data-name":"Path 38427","d":"M8 0a8 8 0 11-8 8 8 8 0 018-8","fill":"#eff2f7"}}),_c('path',{attrs:{"id":"Path_38428","data-name":"Path 38428","d":"M8.081 10.669a.6.6 0 01-.6-.6v-.55a2.3 2.3 0 011.09-2.054 1.507 1.507 0 00.666-1.271 1.037 1.037 0 00-.271-.763 1 1 0 00-.708-.325.688.688 0 00-.121 0 1.335 1.335 0 00-1.452 1.159A.6.6 0 015.5 6.1a2.561 2.561 0 012.615-2.19.927.927 0 01.193 0 2.216 2.216 0 012.128 2.3A2.661 2.661 0 019.3 8.419c-.591.49-.617.633-.617 1.1v.55a.6.6 0 01-.6.6","fill":"#5a677d"}}),_c('path',{attrs:{"id":"Path_38429","data-name":"Path 38429","d":"M8.7 11.788a.595.595 0 10-.6.6.595.595 0 00.6-.6","fill":"#5a677d"}})])])
          )
        }
      }
    